import axios, { CreateAxiosDefaults, InternalAxiosRequestConfig } from "axios";
import { QueryClient } from "@tanstack/react-query";

const INBOX_API_URL = import.meta.env.VITE_APP_INBOX_API_HOST;

const TOKEN_QUERY_KEY = ["INBOX_AUTH_TOKEN"];

interface InboxAuthToken {
  access_token: string;
  token_type: string;
  expires_in: number;
}

let queryClientInstance: QueryClient | null = null;

export const setInboxQueryClient = (queryClient: QueryClient) => {
  queryClientInstance = queryClient;
};

const createInboxClient = (config?: CreateAxiosDefaults) => {
  const instance = axios.create({
    baseURL: INBOX_API_URL,
    timeout: 60000,
    withCredentials: true,
    ...config
  });

  instance.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // Lazily read token from React Query cache
      const tokenData =
        queryClientInstance?.getQueryData<InboxAuthToken>(TOKEN_QUERY_KEY);
      const token = tokenData?.access_token;

      if (token) config.headers.Authorization = `Bearer ${token}`;
      else if (queryClientInstance)
        return Promise.reject(
          new Error("Inbox authentication token not available")
        );

      return config;
    },
    (error) => {
      throw error;
    }
  );

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      throw error;
    }
  );

  return instance;
};

export const inboxClient = createInboxClient();
